import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { useHistory, useLocation, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { motion } from "framer-motion";

import "../../myfin_v2/css/bookclosure.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import commoncss from "../../myfin_v2/css/common.module.css";
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";
import SideBarv2 from "../../WorkSpace/Workspace-v2/Sidbarv2";
import Sidebar from "./../../myfin_v2/elements/Sidebar";
import BookClosureCommentsFilterModal from "./../../myfin_v2/components/bookclosure/BookClosureCommentsFilterModal";
import {
	DisplayCard,
	DisplayCardInactive,
} from "../../myfin_v2/elements/DisplayCards";
import PaginationFooter from "./../../myfin_v2/elements/PaginationFooter";
import StatusIndicator from "../../myfin_v2/elements/StatusIndicator";
import { Button, FilterButton } from "../../myfin_v2/elements/Button";
import BookClosureTable from "../../myfin_v2/elements/BookClosureTable";
import { ReactComponent as LeftArrowIcon } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as FilterIcon } from "../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/search.svg";
import { ReactComponent as SortIcon } from "../../myfin_v2/assets/icons/sort.svg";
import { ReactComponent as CloseGreyIcon } from "../../myfin_v2/assets/icons/close_grey.svg";
import { getAllCommentsApiHandler } from "../Services/ApiHandler";
import Bookclosure from "./Bookclosure";

const BookClosureComments = () => {
	const history = useHistory();

	const location = useLocation();
	const dispatch = useDispatch();
	const { workspaceId } = useParams();
	const a = location.pathname;
	var w_id = a.split("/");
	w_id.shift();
	const bookClosureId = w_id[3];
	const companyId = w_id[4];

	const [commentsData, setCommentsData] = useState([]);
	const [commentsStatistics, setCommentsStatistics] = useState({});
	const [paginationParams, setPaginationParams] = useState(null);
	const [primaryFilter, setPrimaryFilter] = useState("all_comments");
	const [bookClosureCommentsFilterModal, setBookClosureCommentsFilterModal] =
		useState(false);

	const { userData } = useSelector((state) => state.AuthReducer);
	const { assignOptions, approveOptions } = useSelector(
		(state) => state.BookClosureReducer
	);

	const [showSearch, setShowSearch] = useState(false);
	const [searchText, setSearchText] = useState("");
	const [expanded, setExpanded] = useState(false);
	const [sortOrder, setSortOrder] = useState(1)

	const [appliedFilters, setAppliedFilters] = useState({});

	const tableHeaders = {
		comment: "COMMENT",
		task: "TASK",
		assignedTo: "ASSIGNED TO",
		approver: "APPROVER",
		dueDate: "DUE DATE",
		status: "STATUS",
		lastActivity: "LAST ACTIVITY",
	};

	const headerClasses = {
		taskTemplateName: "bkclTableTemplateNameTh",
	};

	useEffect(() => {
		getAllComments();
	}, [sortOrder]);

	const getAllComments = () => {
		const payload = {
			bookClosureID: bookClosureId,
			companyID: companyId,
		};
		getAllCommentsApiHandler(payload, sortOrder)
			.then((response) => {
				setCommentsData(response.data.comments);
				setPaginationParams(response.data.pagination);

				setCommentsStatistics(response.data.statistics[0]);
			})
			.catch((error) => {
				swal(
					"Error",
					error?.response?.data?.error || "Unable to fetch comments",
					"error"
				);
			});
	};

	const paginationHandler = (paginationEvents) => {
		const payload = {
			bookClosureID: bookClosureId,
			companyID: companyId,
			...paginationEvents,
		};
		getAllCommentsApiHandler(payload)
			.then((response) => {
				setCommentsData(response.data.comments);
				setPaginationParams(response.data.pagination);

				setCommentsStatistics(response.data.statistics[0]);
			})
			.catch((error) => {
				swal(
					"Error",
					error?.response?.data?.error || "Unable to fetch comments",
					"error"
				);
			});
	};

	const applyFiltersHandler = (filters) => {
		console.log("filters :::::",filters);

		const payload = {
			bookClosureID: bookClosureId,
			companyID: companyId,
			...filters,
		};
		getAllCommentsApiHandler(payload)
			.then((response) => {
				setCommentsData(response.data.comments);
				setPaginationParams(response.data.pagination);

				setCommentsStatistics(response.data.statistics[0]);
				setBookClosureCommentsFilterModal(false);

				setAppliedFilters(filters);

			})
			.catch((error) => {
				swal(
					"Error",
					error?.response?.data?.error || "Unable to fetch comments",
					"error"
				);
			});
	};

	const redirectToBookClosureHome = () => {
		history.push(`/bookclosure/${workspaceId}`, {
			redirectFilter: { companyID: companyId }
		});
	};

	const openSearch = () => {
		setShowSearch(true);
	};

	const closeSearch = () => {
		setExpanded(false);
		setTimeout(() => setShowSearch(false), 600);
	};

	useEffect(() => {
		if (showSearch) {
			const timeout = setTimeout(() => setExpanded(true), 15);
			return () => clearTimeout(timeout);
		} else {
			setExpanded(false);
		}
	}, [showSearch]);

	const toggleSortOrder = () => {
		setSortOrder((prev) => (prev === 1 ? -1 : 1));
	};

	// Function to map IDs to names
	const getNamesFromIds = (ids, options) => {
		if (!ids || ids.length === 0) return [];
		return options
			.filter((opt) => ids.includes(opt.value))
			.map((opt) => opt.label);
	};


	// useEffect(()=> {
	// 	handleSearch()
	// },[searchText])

	// const handleSearch = () => {
	// 	const payload = {
	// 		bookClosureID: bookClosureId,
	// 		...(searchText && { searchKeyword: searchText }),
	// 	};
	// 	getAllCommentsApiHandler(payload)
	// 		.then((response) => {
	// 			setCommentsData(response.data.comments);
	// 			setPaginationParams(response.data.pagination);

	// 			setCommentsStatistics(response.data.statistics[0]);
	// 		})
	// 		.catch((error) => {
	// 			swal(
	// 				"Error",
	// 				error?.response?.data?.error || "Unable to fetch comments",
	// 				"error"
	// 			);
	// 		});
	// }

	return (
		<div className={commoncss.pageLayout}>
			{/* <Navbar /> */}
			<Sidebar />
			{/* <Bookclosure/> */}
			<div className={`d-flex ${commoncss.pageContent}`}>
				<div className="book-closure-page">
					<SideBarv2 w_id={w_id} active={"bookclosure"} />

					<motion.div
						initial={{ y: -100, opacity: 0 }}
						animate={{ y: 0, opacity: 1 }}
						exit={{ y: 0, opacity: 0 }}
						transition={{ duration: 0.5, ease: "easeInOut" }}
						className="book-closure-content"
					>
						<div className="book-closure-header" style={{ paddingBottom:"0px" }}>
							<div className="header-content" style={{height:"40px"}}>
								<LeftArrowIcon
									width={24}
									height={24}
									className="clickable"
									onClick={redirectToBookClosureHome}
								/>
								<span className="header-title-bookclosure">Comments</span>


								<div className="comments-filter-container">
									{Object.entries(appliedFilters)
										.filter(([_, value]) => value !== null && value !== undefined && (Array.isArray(value) ? value.length > 0 : true))
										.map(([key, value]) => {
											let displayLabel = key
											let displayValue = value;

											if (key === "assigneeID"){
												displayValue = getNamesFromIds(value, assignOptions);
												displayLabel = "Assined to"
											} else if (key === "createdBy"){
												displayValue = getNamesFromIds(value, assignOptions);
												displayLabel = "Created by"
											}else if (key === "status"){
												displayLabel = "Status"
											}else if (key === "dueDate"){
												displayLabel = "Due Date"
											}

											return (
												<span key={key} className="comments-filter-badge">
												<span> {displayLabel} - </span> {Array.isArray(displayValue) ? displayValue.join(", ") : displayValue}
												</span>
											);
										})}
									</div>


								<FilterIcon
									className={commoncss.clickable}
									onClick={() => {
										setBookClosureCommentsFilterModal(
											!bookClosureCommentsFilterModal
										);
									}}
								/>
								&nbsp;

								<div className="searchWrapper">
									{!showSearch && (
										<SearchIcon onClick={openSearch} style={{cursor:"pointer"}} />
									)}

									{showSearch && (
										
										<div className={`searchBox ${expanded ? "expanded" : ""}`}>
											<SearchIcon className="searchInside"/>
											<input
												type="text"
												value={searchText}
												onChange={(e) => setSearchText(e.target.value)}
												placeholder="Search in Comment or Task"
												className="searchInput"
											/>
											<CloseGreyIcon
												style={{cursor:"pointer"}}
												onClick={closeSearch}
											/>
										</div>
									)}
								</div>
								
								
							</div>
						</div>
						<div className="book-closure-data">
							<DisplayCard
								class_={`${primaryFilter === "all_comments"
									? "displayCommentCardActive"
									: "displayCommentCardInactive"
									} padding15 ${commoncss.clickable}`}
								active={primaryFilter === "all_comments" ? true : false}
								onClick={() => {
									applyFiltersHandler({});
									setPrimaryFilter("all_comments");
								}}
								label="ALL COMMENTS"
								value={
									commentsStatistics?.totalComments
										? commentsStatistics?.totalComments
										: 0
								}
							/>
							<DisplayCard
								class_={`${primaryFilter === "assign_to_me"
									? "displayCommentCardActive"
									: "displayCommentCardInactive"
									} padding15 ${commoncss.clickable}`}
								active={primaryFilter === "assign_to_me" ? true : false}
								onClick={() => {
									applyFiltersHandler({ assigneeID: userData._id });
									setPrimaryFilter("assign_to_me");
								}}
								label="ASSIGNED TO ME"
								value={
									commentsStatistics?.assignedCommentsCount
										? commentsStatistics?.assignedCommentsCount
										: 0
								}
							/>
							<DisplayCard
								class_={`${primaryFilter === "overdue"
									? "displayCommentCardActive"
									: "displayCommentCardInactive"
									} padding15 ${commoncss.clickable}`}
								active={primaryFilter === "overdue" ? true : false}
								onClick={() => {
									applyFiltersHandler({ status: "overdue" });
									setPrimaryFilter("overdue");
								}}
								label="OVERDUE"
								value={
									commentsStatistics?.overdueCount
										? commentsStatistics?.overdueCount
										: 0
								}
							/>
							<DisplayCard
								class_={`${primaryFilter === "unresolved"
									? "displayCommentCardActive"
									: "displayCommentCardInactive"
									} padding15 ${commoncss.clickable}`}
								active={primaryFilter === "unresolved" ? true : false}
								onClick={() => {
									applyFiltersHandler({ status: "unresolved" });
									setPrimaryFilter("unresolved");
								}}
								label="UNRESOLVED"
								value={
									commentsStatistics?.unresolvedCount
										? commentsStatistics?.unresolvedCount
										: 0
								}
							/>
							<DisplayCard
								class_={`${primaryFilter === "resolved"
									? "displayCommentCardActive"
									: "displayCommentCardInactive"
									} padding15 ${commoncss.clickable}`}
								active={primaryFilter === "resolved" ? true : false}
								onClick={() => {
									applyFiltersHandler({ status: "resolved" });
									setPrimaryFilter("resolved");
								}}
								label="RESOLVED"
								value={
									commentsStatistics?.resolvedCount
										? commentsStatistics?.resolvedCount
										: 0
								}
							/>
							<DisplayCard
								class_={`${primaryFilter === "closed"
									? "displayCommentCardActive"
									: "displayCommentCardInactive"
									} padding15 ${commoncss.clickable}`}
								active={primaryFilter === "closed" ? true : false}
								onClick={() => {
									applyFiltersHandler({ status: "closed" });
									setPrimaryFilter("closed");
								}}
								label="CLOSED COMMENTS"
								value={
									commentsStatistics?.closedCount
										? commentsStatistics?.closedCount
										: 0
								}
							/>
						</div>
						<br />
						<div
							className={`${commoncss.pdlr30} ${commoncss.dFlexJustifysb} ml-1`}
						>
							<div>
								<span
									onClick={() => {
										applyFiltersHandler({});
										setPrimaryFilter("all_comments");
									}}
								>
									<FilterButton
										active={primaryFilter === "all_comments" ? true : false}
										label="All Comments"
										class_={`px-2 py-1 ${commoncss.clickable}`}
									/>
								</span>
								&ensp;
								<span
									onClick={() => {
										applyFiltersHandler({ assigneeID: userData._id });
										setPrimaryFilter("assign_to_me");
									}}
								>
									<FilterButton
										active={primaryFilter === "assign_to_me" ? true : false}
										label="Assigned to me"
										class_={`px-2 py-1 ${commoncss.clickable}`}
									/>
								</span>
								&ensp;
								<span
									onClick={() => {
										applyFiltersHandler({ createdBy: userData._id });
										setPrimaryFilter("created_by_me");
									}}
								>
									<FilterButton
										active={primaryFilter === "created_by_me" ? true : false}
										label="Created by me"
										class_={`px-2 py-1 ${commoncss.clickable}`}
									/>
								</span>
							</div>
							<SortIcon className="mr-3" style={{cursor:"pointer"}} onClick={toggleSortOrder} />
						</div>
						<div className={`${commoncss.pdlr30} ${commoncss.m_tb_20} mt-2 mb-0`}>
							<div className={`table-container-book-closure`}>
								<div className={bookclosuretablecss.bookClosureTableContainer} style={{ width: "100%",height: "55vh", overflow:"auto" }}>
									<table className={bookclosuretablecss.bookClosureTable}>
										<thead>
											<tr>
												<th style={{ width: "250px" }}>COMMENT</th>
												<th style={{ width: "250px" }}>TASK</th>
												<th>ASSIGNED TO</th>
												<th>APPROVER</th>
												<th>DUE DATE</th>
												<th>STATUS</th>
												<th>LAST ACTIVITY</th>
											</tr>
										</thead>
										<tbody>
											{commentsData && commentsData.length > 0 ? (
												commentsData
												.filter((obj) => {
													if (!searchText) return true;

													const lowerSearch = searchText.toLowerCase();

													return (
														obj?.comment?.text?.toLowerCase().includes(lowerSearch) ||
														obj?.task?.name?.toLowerCase().includes(lowerSearch) ||
														obj?.comment?.assigneeData?.name?.toLowerCase().includes(lowerSearch) ||
														obj?.comment?.createdByData?.email?.toLowerCase().includes(lowerSearch) ||
														obj?.comment?.status?.toLowerCase().includes(lowerSearch)
													);
												})
												.map((obj, index) => (
													<React.Fragment key={index}>
														<tr
															key={index}
														// onClick={() => ViewobjMore(obj._id)}
														>
															<td>{obj?.comment?.text}</td>
															<td>{obj?.task?.name}</td>
															<td>
																{obj?.comment?.assigneeData.name}
															</td>
															<td>{obj?.comment?.createdByData?.name}</td>
															<td>
																{obj?.comment?.dueDate
																	? dayjs(obj?.comment?.dueDate).format(
																		"DD-MMM-YYYY"
																	)
																	: ""}
															</td>
															<td>
																{" "}
																<StatusIndicator
																	status={obj?.comment?.status}
																/>
															</td>
															<td>
																{obj?.comment?.lastActivity
																	? dayjs(obj?.comment?.lastActivity).format(
																		"DD-MMM-YYYY"
																	)
																	: ""}
															</td>
														</tr>
													</React.Fragment>
												))
											) : (
												<tr>
													<td
														colSpan={6}
														className="text-secondary text-center font-size-16 custom-font-600 font-inter"
													>
														{" "}
														No Comments.
													</td>
												</tr>
											)}
										</tbody>
									</table>
								</div>
							</div>
						</div>
						{paginationParams && (
							<PaginationFooter
								paginationParams={paginationParams}
								paginationHandler={paginationHandler}
							/>
						)}
					</motion.div>
				</div>
			</div>
			{bookClosureCommentsFilterModal && (
				<BookClosureCommentsFilterModal
					setBookClosureCommentsFilterModal={setBookClosureCommentsFilterModal}
					assignOptions={assignOptions}
					approveOptions={approveOptions}
					applyFiltersHandler={applyFiltersHandler}
				/>
			)}
		</div>
	);
};

export default BookClosureComments;
